<template>
  <div class="ruler-wrapper">
    <div class="text">{{ $t('discover.check_my_size') }}</div>
    <img
      class="avatar"
      :style="{ top: avatarPos }"
      src="@/assets/DefaultCloudzet/HomePage/ruler-avatar.svg"
    />
    <svg
      class="svg-ruler"
      width="19"
      height="155"
      viewBox="0 0 19 155"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5 7.5V14.5H11.5C7.63401 14.5 4.5 11.366 4.5 7.5C4.5 3.63401 7.63401 0.5 11.5 0.5C15.366 0.5 18.5 3.63401 18.5 7.5Z"
        stroke="#262626"
      />
      <path
        d="M14.5 7.5V14.5H7.5C3.63401 14.5 0.5 11.366 0.5 7.5C0.5 3.63401 3.63401 0.5 7.5 0.5C11.366 0.5 14.5 3.63401 14.5 7.5Z"
        fill="white"
        stroke="#262626"
      />
      <circle cx="7.5" cy="7.5" r="2" fill="white" stroke="#262626" />
      <path
        :fill="lineGradient"
        clip-rule="evenodd"
        d="M14.9978 154C14.9978 154.552 15.4455 155 15.9978 155H16.9978C17.5501 155 17.9978 154.552 17.9978 154V6.15979C17.9978 3.31012 15.0877 1 11.4978 1C11.4148 1 11.3322 1.00124 11.25 1.00368C13.4905 2.03334 14.9978 3.95684 14.9978 6.15979V154Z"
      />
      <path
        fill="#ffffff" fill-opacity="0.5"
        clip-rule="evenodd"
        d="M14.9978 154C14.9978 154.552 15.4455 155 15.9978 155H16.9978C17.5501 155 17.9978 154.552 17.9978 154V6.15979C17.9978 3.31012 15.0877 1 11.4978 1C11.4148 1 11.3322 1.00124 11.25 1.00368C13.4905 2.03334 14.9978 3.95684 14.9978 6.15979V154Z"
      />
      <defs>
        <linearGradient
          id="tight-gradient"
          x1="0"
          y1="0"
          x2="0"
          y2="155"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#FE504F" />
          <stop offset="0.5" stop-color="#FDFE4F" />
          <stop offset="1" stop-color="#4DFE51" />
        </linearGradient>
        <linearGradient
          id="loosen-gradient"
          x1="0"
          y1="0"
          x2="0"
          y2="155"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#4DFE51" />
          <stop offset="0.5" stop-color="#4FFAFE" />
          <stop offset="1" stop-color="#4D4DFD" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    ratio: Number,
  },
  computed: {
    avatarPos() {
      const threshhold = 0.5;
      const ratio = this.ratio > threshhold ? (this.ratio - 0.5) * 2 : this.ratio * 2;
      let top = ratio * 100;
      if (top > 90) {
        top = 90;
      }
      if (top < 7) {
        top = 7;
      }
      return `${top}%`;
    },
    lineGradient() {
      return this.ratio > 0.5 ? 'url(#loosen-gradient)' : 'url(#tight-gradient)';
    },
  },
};
</script>

<style lang="scss" scoped>
.ruler-wrapper {
  position: absolute;
  display: flex;
  right: 0;
  padding-right: 2rem;
  top: -1.75rem;
  font-weight: normal;
}
.text {
  margin-right: 0.5rem;
  font-size: 14px;
}

.avatar {
  position: absolute;
  right: 7%;
  top: 0%;
  will-change: top;
  transition: top 2s ease-out;
}

.svg-ruler {
  margin-top: 0.25rem;
}
</style>
